import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiResponse, getReward } from '~/api';
import { ApiError, EmptyObject, PostRewardRequest } from '~/types';
import useToast from '~/store/useToast';
import dartKey from './dartKey';

interface DartRewardParams {
  timezone_iana: string;
  type: 'daily' | 'survey';
}

const useRewardMutation = () => {
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  return useMutation<ApiResponse<EmptyObject>, ApiError, PostRewardRequest>({
    mutationFn: async ({ timezone_iana, type }: DartRewardParams) =>
      getReward({ timezone_iana, type }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: dartKey.getDarts() });
      queryClient.invalidateQueries({
        queryKey: dartKey.getRewardStatus(),
      });
    },
    onError: (error) => {
      if (error.status === 409) {
        showToast('error', 'Reward already claimed.');
      } else {
        showToast('error', 'Failed to survey reward');
      }
      queryClient.invalidateQueries({ queryKey: dartKey.getRewardStatus() });
    },
  });
};

export default useRewardMutation;
